export const tabs = () => {
    const tabButtons = document.querySelectorAll('[data-tabs="tab"] .tabs__btn');
    const tabContents = document.querySelectorAll('[data-content]');

    tabButtons.forEach((btn) => {
        btn.addEventListener('click', () => {
            const target = btn.dataset.tab;

            tabButtons.forEach((b) => b.classList.remove('tabs__btn--active'));
            tabContents.forEach((c) => c.classList.remove('active'));

            btn.classList.add('tabs__btn--active');
            const currentContent = document.querySelector(`[data-content="${target}"]`);
            if (currentContent) {
                currentContent.classList.add('active');
            }
        });
    });

}

